import React from "react";

type Props = {
	number: number
	title: string
	description: string
}

function TimelineItem({
	number,
	title,
	description,
}: Props) {

	return (
		<div className="flex gap-2 items-center text-white">
			<div className="min-w-[40px] min-h-[40px] w-10 h-10 bg-sky-400 rounded-full flex justify-center items-center font-bold">
				{ number }
			</div>
			<div className="flex flex-col gap-2">
				<div className="text-base font-bold">
					{ title }
				</div>
				<div className="text-sm font-normal">
					{ description }
				</div>
			</div>
		</div>
	);
}

export default TimelineItem;